import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ZoneElement, ListZones, ListCountries } from '../models/zone.model';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../environments/environment';

import { LanguageService } from './language.service';

import * as countriesList from '../../assets/json/countries.json';

const API_URL = environment.API_URL


@Injectable({
  providedIn: 'root'
})

export class ZoneService {

  lstZones: ListZones[] = [];

  constructor(private http: HttpClient, private langService: LanguageService) { }

  items: any = [];

  getAllZones(company_id: number): Observable<ZoneElement[]> {
    const API_URL_USR = `${API_URL}/companies/${company_id}/zones`;
    return this.http.get<ZoneElement[]>(`${API_URL_USR}`);
  }

  getZoneById(id: number, company_id: number): Observable<ZoneElement[]> {
    const API_URL_USR = `${API_URL}/companies/${company_id}/zones/${id}`;
    return this.http.get<ZoneElement[]>(`${API_URL_USR}`);
  }

  addZone(zone: ZoneElement, company_id: number):Observable<any>  {
    const API_URL_USR = `${API_URL}/companies/${company_id}/zones`;
    return this.http.post(`${API_URL_USR}`, zone);
  }

  updateZone(id: number, zone: ZoneElement, company_id: number):Observable<any>  {
    const API_URL_USR = `${API_URL}/companies/${company_id}/zones/${id}`;
    return this.http.put(`${API_URL_USR}`, zone);
  }

  deleteZone(id: number, company_id: number):Observable<any>  {
    const API_URL_USR = `${API_URL}/companies/${company_id}/zones/${id}`;
    return this.http.delete(`${API_URL_USR}`);
  }

  getCompanyZonesList(company_id: number):ListZones[] {
    this.lstZones=[];

    const req = this.getAllZones(company_id);
    req.subscribe({
      next: (res) => {
        this.items = res;
        if(this.items.data != null){
          for (let itm of this.items.data ){
            this.lstZones.push( {value: itm.id, viewValue: (itm.name)} );
          }
        }
      },
      error: (e) => {
        console.error(e);
        let msg = e.error.message;
      },
    });

    return this.lstZones;
  }

  getCountries():ListCountries[] {
    const selectedLang = this.langService.getLang();
    const result:ListCountries[] = [];
    countriesList.data.forEach(country => {
      switch (selectedLang) {
        case "en":
          result.push({ value: country.value, viewValue: country.en })
          break;
        default:
          // Agregar el valor y ordenar la lista por la propiedad 'viewValue'
          result.push({ value: country.value, viewValue: country.es })
          result.sort(((a, b) => a.viewValue > b.viewValue ? 1 : b.viewValue > a.viewValue ? -1 : 0))
          break;
      }
    });
    return result;
  }

}
